module.exports = __webpack_public_path__ + "img/banner8.411809d1.png";